<template>
    <div class="mt-10">
        <div class="container">
            <div class="row" v-show="downloading">
                <div class="col-lg-12 text-center py-3">
                    <b-spinner small label="Espere ..."></b-spinner>
                    <span class="p-1">Espere un momento...</span>
                </div>
            </div>
            <div class="row" v-if="!downloading">
                <div class="col-lg-6">
                    <h3 class="font-weight-light">Detalle de empleo</h3>
                    <div class="job_info">
                        <label for="">Título del empleo</label>
                        <h5>{{job.titulo}}</h5>
                        <label for="">Descripción del empleo</label>
                        <p class="text-justify" v-html="job.descripcion"></p>
                        <label for="">Periodo</label>
                        <ul>
                            <li>{{job.periodo}}</li>
                        </ul>
                        <label for="">Tipo de empleo</label>
                        <ul>
                            <li>{{job.tipo_empleo}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6">
                    <h3 class="font-weight-light">Candidatos recomendados</h3>
                    <label for="">Estos son los candidatos que más se adaptan a tu vacante</label>

                    <CandidateElement v-for="match in job.matches.match_data" :key="match.id" :match="match" :job_id="job.id"/>
                </div>
            </div>    
        </div>
    </div>
</template>
<script>
import CandidateElement from './components/CandidateElement'
export default {
    components:{
        'CandidateElement': CandidateElement
    },
    data() {
        return {
            downloading: false,
            job: {}
        }
    },
    created() {
        let id = this.$route.params.id
        this.downloading = true
        this.api.get('candidate/job?job_id=' + id + '&section=gold').then(({data}) => {
            if(data.matches.isGold){
                this.job = data
                this.downloading = false
            }else{
                this.$router.push('/memberships')
            }
        }).catch(err => {
            this.downloading = false
        })
    },
}
</script>


// WEBPACK FOOTER //
// src/components/#pages/candidates_gold/CandidatesRecomendation.vue